import { useBreakpoint } from "@weco/ui";

export type CallLayoutTier = "mobile" | "compact" | "desktop";

/**
 * Collapses the shared @weco/ui breakpoint flags into a single semantic tier
 * used by the in-call components. Inherits useBreakpoint's matchMedia-absent
 * default (no window / jsdom) → "desktop", so SSR and unit tests render the
 * full, non-collapsed control bar.
 */
export function useCallLayoutTier(): CallLayoutTier {
  const { isMobile, isCompactViewport } = useBreakpoint();
  if (isMobile) return "mobile";
  if (isCompactViewport) return "compact";
  return "desktop";
}
